import React, {useState, useEffect} from 'react';
import {Link} from 'react-router-dom';
import {Dropdown, DropdownItem, DropdownMenu, DropdownToggle} from 'reactstrap';
import avatar1 from "../../assets/images/users/avatar-1.jpg";
import {getLoggedInMerchantId, getLoggedInUserId, getLoggedInUserName, getLoggedInUserRole} from "../../helpers/backend_helper";
import {ROLES} from "../../constants/userRoleMapping";
import {MerchantCreditStatus} from "../../types/MerchantCredit";
import MerchantService from "../../services/MerchantService";
import {logError} from "../../helpers/log_helper";

const ProfileDropdown = () => {

    const [userName, setUserName] = useState<string>('');
    const [userRole, setUserRole] = useState<number>(0);
    const [userRoleName, setUserRoleName] = useState<string>('');
    const [myUserId, setMyUserId] = useState<string>('');
    const [isProfileDropdown, setIsProfileDropdown] = useState(false);
    const [userCredits, setUserCredits] = useState<MerchantCreditStatus>();

    useEffect(() => {

        setUserName(getLoggedInUserName())
        setUserRole(getLoggedInUserRole())
        setMyUserId(getLoggedInUserId())
        loadCredits(getLoggedInMerchantId());

        const myRole = ROLES.find(role => role.id === getLoggedInUserRole())
        if (myRole?.label) {
            setUserRoleName(myRole.label)
        }


    }, [])

    const loadCredits = async (merchantId: string) => {
        if (!merchantId) {
            return;
        }

        try {
            const myCredits: MerchantCreditStatus = await MerchantService.fetchMerchantCredits(merchantId); // page+1 because Laravel uses 1-based index
            setUserCredits(myCredits)
        } catch (error) {
            logError("Error loading merchant credits:", error)
        } finally {

        }
    }


    const toggleProfileDropdown = () => {
        setIsProfileDropdown(!isProfileDropdown);
    };

    useEffect(() => {

        // Set interval to call API every 30 seconds
        const interval = setInterval(() => loadCredits(getLoggedInMerchantId()), 30000);
        // Cleanup function to clear interval when component unmounts
        return () => clearInterval(interval);
    }, []);


    return (
        <React.Fragment>
            <Dropdown isOpen={isProfileDropdown} toggle={toggleProfileDropdown}
                      className="ms-sm-3 header-item topbar-user">
                <DropdownToggle tag="button" type="button" className="btn">
                    <span className="d-flex align-items-center">
                        <img className="rounded-circle header-profile-user" src={avatar1}
                             alt="Header Avatar"/>
                        <span className="text-start ms-xl-2">
                            <span
                                className="d-none d-xl-inline-block ms-1 fw-medium user-name-text"> {userName || "Admin"}</span>
                            <span
                                className="d-none d-xl-block ms-1 fs-12 text-muted user-name-sub-text">{userRoleName || ''}</span>
                        </span>
                    </span>
                </DropdownToggle>
                <DropdownMenu className="dropdown-menu-end">
                    <h6 className="dropdown-header">Welcome {userName}!</h6>
                    <DropdownItem className='p-0'>
                        <Link to={`/users/${myUserId}`} className="dropdown-item">
                            <i className="mdi mdi-account-circle text-muted fs-16 align-middle me-1"></i>
                            <span className="align-middle">Profile</span>
                        </Link>
                    </DropdownItem>
                    <div className="dropdown-divider"></div>
                    {userRole === 3 ? (
                        <DropdownItem className='p-0'>
                            <Link to="/merchants/me" className="dropdown-item">
                                <i
                                    className="mdi mdi-wallet text-muted fs-16 align-middle me-1"></i> <span
                                className="align-middle">Credits Balance: <b>{userCredits?.creditsAvailable?.toString() || ''}</b></span>
                            </Link>
                        </DropdownItem>
                    ) : ''}
                    <DropdownItem className='p-0'>
                        <Link to="/logout" className="dropdown-item">
                            <i
                                className="mdi mdi-logout text-muted fs-16 align-middle me-1"></i> <span
                            className="align-middle" data-key="t-logout">Logout</span>
                        </Link>
                    </DropdownItem>
                </DropdownMenu>
            </Dropdown>
        </React.Fragment>
    );
};

export default ProfileDropdown;
